export default __webpack_public_path__ + "static/media/sz.3cc762cb.svg";